





















































































































































import { Module } from '@/models/configurator/module';

import Vue, { PropType } from 'vue';
import { mapActions } from 'vuex';
import ModuleDetailMenu from './ModuleDetailMenu.vue';
import ModuleImage from './ModuleImage.vue';

export default Vue.extend({
  components: { ModuleDetailMenu, ModuleImage },
  name: 'ModuleDetailCard',

  props: {
    module: Object as PropType<Module>,

    isCloning: Boolean
  },

  data() {
    return {
      loading: false
    };
  },

  methods: {
    editModule(module: Module) {
      this.$emit('edit-module', module);
    },
    deleteModule() {
      this.$emit('delete-module');
    },

    cloneModule(module: Module) {
      this.$emit('clone-module', module);
    }
  }
});
